<template>
  <div class="fast-survey">
    <div class="row">
      <div class="col-md-12 top">
        <i class="fas fa-chevron-left"></i>
        <span @click="returToPreviewsPage" class="return ml-2">{{
          $t("events.newEvent.back")
        }}</span>
      </div>
    </div>
    <h1 v-if="!this.$route.params.nameSurvey">
      {{ $t("events.newEvent.exitSurvey") }}
    </h1>
    <h1 v-if="this.$route.params.nameSurvey">
      {{ this.$route.params.nameSurvey }}
    </h1>
    <div v-if="isActiveAlert">
      <b-alert v-model="isActiveAlert" variant="danger" dismissible id="alert"
        >Es necesario llenar todos los campos!</b-alert
      >
    </div>
    <p class="mt-3">{{ $t("surveys.newSurvey.bodySurvey") }}</p>
    <p class="black">{{ $t("events.newEvent.requireFields") }}</p>
    <form class="mt-5">
      <label class="font-b"
        >{{ $t("surveys.newSurvey.description") }} (*)</label
      >
      <input
        type="text"
        placeholder="Descripcion"
        v-model="surveyDescription"
        :disabled="this.$route.params.isDetails"
      />
      <div class="collapse-section mt-5">
        <div>
          <b-card
            v-for="(item, index) in questions"
            :key="index"
            no-body
            class="mb-4 vs-collapse"
          >
            <b-card-header
              header-tag="header"
              class="p-1"
              role="tab"
              v-b-toggle="'accordion-' + index"
            >
              <p id="titleQuestion">{{ item.title }}</p>
              <p>
                <small class="gray" id="type">{{ item.type }}</small>
              </p>
            </b-card-header>
            <div class="icons" :class="isDetails ? 'desaparecer' : ''">
              <i
                class="far fa-edit"
                @click="openEditModal(index, item.title)"
              ></i>
              <i class="far fa-trash-alt" @click="openDeleteModal(index)"></i>
            </div>
            <b-collapse
              visible
              :id="'accordion-' + index"
              accordion="my-accordion"
              role="tabpanel"
            >
              <!--Div para opcion multiple y check-->
              <div
                v-if="
                  item.numberType === 'radio_button' ||
                  item.numberType === 'multiple_option'
                "
                class="multiple"
              >
                <div
                  v-for="(nuevo, index2) in item.multipleOptionItems"
                  :key="index2"
                >
                  <div
                    ref="mydiv"
                    class="input-option multi-input"
                    :id="'elem-' + index2"
                  >
                    <label class="font-b">
                      {{ $t("surveys.newSurvey.fastSurvey.option") }}
                      {{ +index2 + 1 }} (*)
                    </label>
                    <i
                      :class="{
                        'far fa-circle': item.numberType === 'radio_button',
                        'fas fa-check-square':
                          item.numberType === 'multiple_option',
                      }"
                    ></i>
                    <input
                      type="text"
                      v-model="
                        questions['question' + item.index].multipleOptionItems[
                          index2 + ''
                        ].name
                      "
                      :disabled="isDetails"
                    />
                    <span
                      v-if="index2 > 2"
                      class="remove"
                      :class="isDetails ? 'desaparecer' : ''"
                      @click="removeMultiOptionInput(index2, item)"
                      >- Remover opción</span
                    >
                  </div>
                </div>
              </div>
              <div
                v-if="
                  item.numberType === 'radio_button' ||
                  item.numberType === 'multiple_option'
                "
                class="add-option"
              >
                <span
                  :class="isDetails ? 'desaparecer' : ''"
                  @click="addMultiOptionInput(item)"
                  >+ Agregar opción</span
                >
              </div>
              <!--Div para opcion multiple y check-->
              <!--Div switch-->
              <div v-if="item.numberType === 'binary'" class="switch">
                <div class="input-option">
                  <label class="font-b"
                    >{{ $t("surveys.newSurvey.fastSurvey.option") }} 1
                    (*)</label
                  >
                  <input
                    type="text"
                    v-model="
                      questions['question' + item.index].multipleOptionItems[
                        '0'
                      ].name
                    "
                    :disabled="isDetails"
                  />
                </div>
                <div class="img">
                  <img src="../../assets/img/icon/icon_switch.svg" alt />
                </div>
                <div class="input-option">
                  <label class="font-b"
                    >{{ $t("surveys.newSurvey.fastSurvey.option") }} 2
                    (*)</label
                  >
                  <input
                    type="text"
                    v-model="
                      questions['question' + item.index].multipleOptionItems[
                        '1'
                      ].name
                    "
                    :disabled="isDetails"
                  />
                </div>
              </div>
              <!--Div switch-->
              <!--Div open cuestion-->
              <div v-if="item.numberType === 'open'" class="open-question">
                <div class="text-area-option">
                  <label>Comentarios adicionales</label>
                  <br />
                  <textarea
                    name
                    id
                    cols="20"
                    rows="5"
                    disabled
                    placeholder="Escribe"
                  ></textarea>
                </div>
              </div>
              <!--Div open cuestion-->
              <!--Div open stars-->
              <div v-if="item.numberType === 'number'" class="stars">
                <img
                  src="@/assets/img/icon/stars.png"
                  alt
                  title="Los usuarios podrán contestar en una escala del 0 al 5, en intervalos de 0.5. "
                />
              </div>
              <!--Div open Slider-->

              <div v-if="item.numberType === 'range'" class="stars">
                <img src="@/assets/img/icon/slider.png" alt />
              </div>
              <!-- Div open emoticons -->
              <div v-if="item.numberType === 'emoji'" class="emoticons">
                <div class="sentimiento-section mb-3">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">1</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[0].emoji_type ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[0].emoji_type ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[0].emoji_type ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[0].emoji_type ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          :class="isDetails ? 'disabled-class' : ''"
                          @click="showEmoji(1)"
                          class="select-emoticon"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[0].name"
                          :disabled="isDetails"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal1 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 1, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 1, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 1, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 1, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
                <div class="sentimiento-section mb-3">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">2</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[1].emoji_type ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[1].emoji_type ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[1].emoji_type ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[1].emoji_type ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          :class="isDetails ? 'disabled-class' : ''"
                          @click="showEmoji(2)"
                          class="select-emoticon"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[1].name"
                          :disabled="isDetails"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal2 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 2, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 2, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 2, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 2, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
                <div class="sentimiento-section mb-5">
                  <div class="selecciona">
                    <ul>
                      <li>
                        <span class="emoticon-number">3</span>
                      </li>
                      <li>
                        <img
                          :src="
                            item.multipleOptionItems[2].emoji_type ===
                            'grader_cara_feliz'
                              ? emojiFeliz
                              : item.multipleOptionItems[2].emoji_type ===
                                'grader_cara_enojo'
                              ? emojiEnojado
                              : item.multipleOptionItems[2].emoji_type ===
                                'grader_cara_neutro'
                              ? emojiIndiferente
                              : item.multipleOptionItems[2].emoji_type ===
                                'grader_cara_tristeza'
                              ? emojiTriste
                              : ''
                          "
                          alt
                        />
                      </li>
                      <li>
                        <span
                          :class="isDetails ? 'disabled-class' : ''"
                          @click="showEmoji(3)"
                          class="select-emoticon"
                          >Selecciona emoticon</span
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="sentimiento">
                    <ul>
                      <li>
                        <p>Sentimiento</p>
                      </li>
                      <li>
                        <input
                          type="text"
                          v-model="item.multipleOptionItems[2].name"
                          :disabled="isDetails"
                        />
                      </li>
                    </ul>
                  </div>
                  <div
                    class="sentimientos-imgs"
                    :class="emojiModal3 ? '' : 'desaparecer'"
                  >
                    <img
                      @click="selectFeeling('grader_cara_feliz', 3, item)"
                      src="@/assets/img/icon/emoticon/feliz.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_enojo', 3, item)"
                      src="@/assets/img/icon/emoticon/enojado.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_neutro', 3, item)"
                      src="@/assets/img/icon/emoticon/indiferente.png"
                      alt
                    />
                    <img
                      @click="selectFeeling('grader_cara_tristeza', 3, item)"
                      src="@/assets/img/icon/emoticon/triste.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>
        </div>
      </div>

      <div class="add-question mt-5" :class="isDetails ? 'disabled-class' : ''">
        <div class="add-square">
          <p>+</p>
        </div>
        <b-dropdown
          id="dropdownMenuButton"
          text="Agregar pregunta"
          class="ml-5 add-question-dropdown"
        >
          <b-dropdown-item @click="openModal('Opción única')"
            >Opción única</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Switch')">Switch</b-dropdown-item>
          <b-dropdown-item @click="openModal('Calificación')"
            >Calificación</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Opción múltiple')"
            >Opción múltiple</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Emoticons')"
            >Emoticons</b-dropdown-item
          >
          <b-dropdown-item @click="openModal('Slider')">Slider</b-dropdown-item>
          <b-dropdown-item @click="openModal('Pregunta abierta')"
            >Pregunta abierta</b-dropdown-item
          >
        </b-dropdown>
      </div>
      <div class="validity mt-5">
        <label class="font-b">{{ $t("surveys.newSurvey.expire") }}</label>
        <br />
        <div class="dates">
          <div class="date-from">
            <label for>{{ $t("surveys.newSurvey.from") }}</label>
            <input
              type="date"
              placeholder="dd/mm/yyyy"
              v-model="date1"
              :disabled="true"
            />
          </div>
          <div class="time-from">
            <label for>{{ $t("surveys.newSurvey.time") }}</label>
            <vue-timepicker :disabled="true" v-model="time1"></vue-timepicker>
          </div>
          <div class="date-to">
            <label for>{{ $t("surveys.newSurvey.to") }}</label>
            <input
              :disabled="true"
              type="date"
              placeholder="dd/mm/yyyy"
              v-model="date2"
            />
          </div>
          <div class="time-to">
            <label for>{{ $t("surveys.newSurvey.time") }}</label>
            <vue-timepicker :disabled="true" v-model="time2"></vue-timepicker>
          </div>
        </div>
      </div>
    </form>
    <div class="footer-buttons">
      <span
        v-if="isEditEvent || !isDetails"
        class="control cancel-btn"
        @click="cancelCreate"
        >{{ $t("surveys.newSurvey.cancelBtn") }}</span
      >
      <button
        type="control button"
        class="btn-save"
        v-if="isEditEvent || !isDetails"
        @click="openWarningModal"
      >
        {{ $t("surveys.modal.publish") }}
      </button>
      <!-- Boton para regresar cuando solo es detalles -->
    </div>
    <!-- Modal para crear preguntas -->
    <Modal v-if="modalActive" v-on:closeModal="closeModal">
      <template #header>
        <h6 v-if="questionModal" class="modal-title">
          {{ $t("surveys.modal.newQuestion") }} {{ newQuestionTitle }}
        </h6>
        <h6 v-if="editModal" class="modal-title">
          {{ $t("surveys.modal.editQuestion") }}
        </h6>
        <h6 v-if="deleteModal" class="modal-title">
          {{ $t("surveys.modal.delQuestion") }}
        </h6>
        <h6 v-if="warningModal">¡Atención!</h6>
      </template>
      <template>
        <div>
          <label v-if="questionModal || editModal" for>{{
            $t("surveys.modal.question")
          }}</label>

          <label v-if="deleteModal" for>{{
            $t("surveys.modal.delQuestionDialog")
          }}</label>
          <input
            v-if="questionModal || editModal"
            type="text"
            v-model="nameQuestion"
          />
          <p v-if="warningModal">
            Una vez publicada la encuesta, está no podra editarse
          </p>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">
            {{ $t("surveys.modal.cancel") }}
          </span>
          <button
            v-if="questionModal"
            type="control button"
            class="btn-save"
            :disabled="isLoading"
            @click="addQuestion"
          >
            {{ $t("surveys.modal.save") }}
          </button>
          <button
            v-if="editModal"
            type="control button"
            class="btn-save"
            :disabled="isLoading"
            @click="editQuestion()"
          >
            {{ $t("surveys.modal.edit") }}
          </button>
          <button
            v-if="deleteModal"
            type="control button"
            class="btn-save"
            :disabled="isLoading"
            @click="removeQuestion()"
          >
            {{ $t("surveys.modal.deleteButton") }}
          </button>
          <button
            v-if="warningModal"
            class="btn-save"
            @click="buildNormalQuestion(true)"
          >
            {{ $t("surveys.modal.publish") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Swatches from "vue-swatches";
import API_SERVICE from "@/lib/api/Surveys.js";
import moment from "moment";
const Modal = () => import("@/components/Modal");
import Vue from "vue";
// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";
const api = new API_SERVICE();
// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;

export default {
  components: {
    Swatches,
    VueTimepicker,
    Modal,
  },
  data() {
    return {
      time1: "",
      time2: "",
      idQuestion: null,
      idAnswer: [],
      from: "",
      to: "",
      date1: "",
      date2: "",
      modalActive: false,
      questionModal: false,
      deleteModal: false,
      editModal: false,
      newQuestionTitle: "",
      multiOptionContador: 0,
      questions: {},
      nameQuestion: "",
      indexQuestion: 0,
      editCurrentKey: "",
      surveyDescription: "",
      emojiType1: "grader_cara_feliz",
      emojiType2: "grader_cara_feliz",
      emojiType3: "grader_cara_feliz",
      emojiNumber: 0,
      emoji1: require("@/assets/img/icon/emoticon/feliz.png"),
      emoji2: require("@/assets/img/icon/emoticon/feliz.png"),
      emoji3: require("@/assets/img/icon/emoticon/feliz.png"),
      emojiModal1: false,
      emojiModal2: false,
      emojiModal3: false,
      surveyTypes: null,
      emojiFeliz: require("@/assets/img/icon/emoticon/feliz.png"),
      emojiTriste: require("@/assets/img/icon/emoticon/triste.png"),
      emojiEnojado: require("@/assets/img/icon/emoticon/enojado.png"),
      emojiIndiferente: require("@/assets/img/icon/emoticon/indiferente.png"),
      isActiveAlert: false,
      users: null,
      surveyPercentAnswer: 0,
      editSurveyInfo: null,
      isDetails: false,
      isEditEvent: false,
      warningModal: false,
    };
  },

  methods: {
    openModal: function (name, type) {
      this.modalActive = true;
      this.questionModal = true;
      this.newQuestionTitle = name;
    },
    openWarningModal() {
      this.modalActive = true;
      this.warningModal = true;
    },
    openDeleteModal: function (index) {
      this.modalActive = true;
      this.deleteModal = true;
      this.editCurrentKey = index;
    },
    openEditModal: function (index, name) {
      this.modalActive = true;
      this.editModal = true;
      this.editCurrentKey = index;
      this.nameQuestion = name;
    },
    closeModal: function () {
      this.modalActive = false;
      this.questionModal = false;
      this.deleteModal = false;
      this.editModal = false;
      this.nameQuestion = "";
      this.warningModal = false;
    },
    cancelCreate() {
      if (this.isDetails) {
        this.$router.push({
          name: "Details Event",
          params: {
            id: this.$route.params.eventId,
            details: true,
            isHappeningEvent: this.$route.params.isHappeningEvent,
            name: this.$route.params.surveyObj
              ? this.$route.params.surveyObj.name
              : this.editSurveyInfo.name,
            event: this.$route.params.event,
          },
        });
      } else if (this.isEditEvent) {
        this.$router.push({
          name: "Edit Event",
          params: {
            id: this.$route.params.eventId,
            isEdit: true,
            isHappeningEvent: this.$route.params.isHappeningEvent,
          },
        });
      } else {
        this.$router.push({
          name: "New Event",
          params: {
            name: this.$route.params.surveyObj,
            event: this.$route.params.event,
            isNewEvent: true,
          },
        });
      }
    },
    returToPreviewsPage() {
      if (this.isDetails) {
        this.$router.push({
          name: "Details Event",
          params: {
            id: this.$route.params.eventId,
            details: true,
            isHappeningEvent: this.$route.params.isHappeningEvent,
            surveyId: this.$route.params.id,
            name: this.$route.params.surveyObj
              ? this.$route.params.surveyObj.name
              : this.editSurveyInfo.name,
            event: this.$route.params.event,
          },
        });
      } else if (this.isEditEvent) {
        this.$router.push({
          name: "Edit Event",
          params: {
            id: this.$route.params.eventId,
            isEdit: true,
            isHappeningEvent: this.$route.params.isHappeningEvent,
          },
        });
      } else {
        this.$router.push({
          name: "New Event",
          params: {
            surveyId: this.$route.params.id,
            name: this.$route.params.surveyObj,
            event: this.$route.params.event,
            isNewEvent: true,
          },
        });
      }
    },
    addQuestion: function () {
      let type = this.convertTypeQuestion();
      let multipleOptionItems = {};
      let currentIndex = 3;
      if (type.type === "radio_button" || type.type === "multiple_option") {
        multipleOptionItems = {
          0: { name: "" },
          1: { name: "" },
          2: { name: "" },
        };
      } else if (type.type === "binary") {
        multipleOptionItems = {
          0: { name: "" },
          1: { name: "" },
        };
        currentIndex = 2;
      } else if (
        type.type === "range" ||
        type.type === "number" ||
        type.type === "open"
      ) {
        multipleOptionItems = {
          0: { name: "-" },
        };
        currentIndex = 1;
      } else if (type.type === "emoji") {
        multipleOptionItems = {
          0: {
            name: "",
            emoji_type: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png"),
          },
          1: {
            name: "",
            emoji_type: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png"),
          },
          2: {
            name: "",
            emoji_type: "grader_cara_feliz",
            img: require("../../assets/img/icon/emoticon/feliz.png"),
          },
        };
      }
      this.questions["question" + this.multiOptionContador] = {
        id_type: type.id_type,
        index: this.indexQuestion,
        title: this.nameQuestion,
        type: this.newQuestionTitle,
        numberType: type.type,
        multipleOptionItems: multipleOptionItems,
        currentIndex,
        questionType: type.type,
      };
      this.indexQuestion = this.indexQuestion + 1;
      this.multiOptionContador++;
      this.closeModal();
    },
    editQuestion: function (key) {
      key = this.editCurrentKey;
      this.questions[key].title = this.nameQuestion;
      this.closeModal();
    },
    removeQuestion: function (key) {
      key = this.editCurrentKey;

      delete this.questions[key];
      this.closeModal();
    },
    closeEmoticonsModal: function () {
      this.emojiModal1 = false;
      this.emojiModal2 = false;
      this.emojiModal3 = false;
    },
    buildNormalQuestion: async function (published = false) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let dateFrom = new Date(this.date1);
        let hourFrom = this.time1.split(":")[0];
        let minutesFrom = this.time1.split(":")[1];
        dateFrom.setHours(+hourFrom, +minutesFrom);
        dateFrom.setDate(dateFrom.getDate() + 1);
        this.from = dateFrom;
        let dateTo = new Date(this.date2);
        let hourTo = this.time2.split(":")[0];
        let minutesTo = this.time2.split(":")[1];
        dateTo.setHours(+hourTo, +minutesTo);
        dateTo.setDate(dateTo.getDate() + 1);
        this.to = dateTo;
        let description = this.surveyDescription;
        let question = {};
        let questionObj = null;
        let responseQuestion = 0;
        let responseAnswer = 0;
        let answerObj = {};
        for (const key in this.questions) {
          questionObj = this.questions[key];

          for (const key2 in questionObj.multipleOptionItems) {
            if (questionObj.multipleOptionItems[key2].name === "") {
              this.isActiveAlert = true;
              window.scrollTo(0, 0);

              return;
            }
          }
        }
        let arrayQuestion = [];
        let arrayAnswersQuestion = [];
        for (const key in this.questions) {
          arrayAnswersQuestion = [];
          questionObj = this.questions[key];
          question = {
            question_content: questionObj.title,
            id_type: questionObj.id_type,
            id_surveys: this.$route.params.id,
            status: true,
            question_points: 1,
          };
          if (!questionObj.id) {
            responseQuestion = await api.createQuestion(question);
          } else {
            responseQuestion = { question: { id: questionObj.id } };
          }
          this.questions[key].id = responseQuestion.question.id;
          for (const key2 in questionObj.multipleOptionItems) {
            answerObj = {
              answer: questionObj.multipleOptionItems[key2].name,
              color: "#",
              id_question: responseQuestion.question.id,
              emoji_type: questionObj.multipleOptionItems[key2].emoji_type,
            };

            if (!questionObj.multipleOptionItems[key2].id) {
              responseAnswer = await api.createAnswer(answerObj);
            } else {
              responseAnswer = {
                dataAnswerQuestion: {
                  id: questionObj.multipleOptionItems[key2].id,
                },
              };
            }

            this.questions[key].multipleOptionItems[key2].id =
              responseAnswer.dataAnswerQuestion.id;
            arrayAnswersQuestion.push({
              idAnswer: responseAnswer.dataAnswerQuestion.id,
              color: "#",
              answer: questionObj.multipleOptionItems[key2].name,
              answerEmojiName: questionObj.multipleOptionItems[key2].name,
              answerEmojiType: questionObj.multipleOptionItems[key2].emoji_type,
            });
          }
          arrayQuestion.push({
            idQuestions: responseQuestion.question.id,
            questionContent: this.questions[key].title,
            questionTypes: {
              type: this.questions[key].questionType,
            },
            answers: arrayAnswersQuestion,
          });
        }
        let survey = {
          idSurvey: this.$route.params.id,
          name: this.$route.params.surveyObj.name,
          details: this.surveyDescription,
          validFrom: this.from,
          validTo: this.to,
          points: "0",
          surveyEstimatedTime: this.surveyTime,
          surveyPublished: published,
          surveyType: this.$route.params.surveyType,
          surveyActive: published,
          questions: arrayQuestion,
          surveyEstimatedTime: "30",
          isEvent: true,
        };

        const respSurvey = await api.editSurvey(survey);
        if (this.$route.params.edit) {
          this.$router.push({
            name: "Edit Event",
            params: {
              id: this.$route.params.eventId,
              isEdit: true,
              isHappeningEvent: this.$route.params.isHappeningEvent,
              surveyId: this.$route.params.id,
              name: this.$route.params.surveyObj.name,
            },
          });
        } else {
          this.$router.push({
            name: "New Event",
            params: {
              surveyId: this.$route.params.id,
              name: this.$route.params.surveyObj.name,
              event: this.$route.params.event,
              isNewEvent: true,
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
    showEmoji: function (num) {
      this.emojiNumber = num;
      if (num === 1) {
        this.emojiModal1 = true;
        this.emojiModal2 = false;
        this.emojiModal3 = false;
      } else if (num === 2) {
        this.emojiModal1 = false;
        this.emojiModal2 = true;
        this.emojiModal3 = false;
      } else {
        this.emojiModal1 = false;
        this.emojiModal2 = false;
        this.emojiModal3 = true;
      }
      this.emojiModal = true;
    },
    selectFeeling: function (emoji, numberEmoji, item) {
      let imgEmoji =
        emoji === "grader_cara_enojo"
          ? require("../../assets/img/icon/emoticon/enojado.png")
          : emoji === "grader_cara_feliz"
          ? require("../../assets/img/icon/emoticon/feliz.png")
          : emoji === "grader_cara_neutro"
          ? require("../../assets/img/icon/emoticon/indiferente.png")
          : emoji === "grader_cara_tristeza"
          ? require("../../assets/img/icon/emoticon/triste.png")
          : "";

      let clonado = this.lodash.cloneDeep(this.questions);

      clonado["question" + item.index].multipleOptionItems[
        numberEmoji - 1 + ""
      ] = {
        id:
          clonado["question" + item.index].multipleOptionItems[
            numberEmoji - 1 + ""
          ].id,
        name: "",
        emoji_type: emoji,
        img: imgEmoji,
      };
      clonado["question" + item.index].v = 1;
      clonado["question" + item.index].currentIndex = item.currentIndex + 1;
      this.questions = clonado;
      this.emojiModal1 = false;
      this.emojiModal2 = false;
      this.emojiModal3 = false;
    },
    fillNormalSurvey: function (obj) {
      if (this.$route.params.controlNumbers) {
        this.users = this.$route.params.controlNumbers;
      } else {
        this.users = obj.assignedUsers;
      }

      this.surveyTime = obj.surveyEstimatedTime;
      let from = moment(obj.validFrom).format("YYYY-MM-DD");
      let to = moment(obj.validTo).format("YYYY-MM-DD");
      this.date1 = from;
      this.date2 = to;
      let hours1 = obj.validFrom.split("T")[1].split(".")[0].split(":")[0];
      let minutes1 = obj.validFrom.split("T")[1].split(".")[0].split(":")[1];
      let hourF = hours1 + ":" + minutes1;
      let hours2 = obj.validTo.split("T")[1].split(".")[0].split(":")[0];
      let minutes2 = obj.validTo.split("T")[1].split(".")[0].split(":")[1];
      let hourT = hours2 + ":" + minutes2;
      this.time2 = hourT;
      this.time1 = hourF;
      let question = null;
      let identifyType = {};
      let currentIndex = 0;
      let multipleOptionItems = {};
      let index3 = 0;
      for (let index = 0; index < obj.questions.length; index++) {
        multipleOptionItems = {};
        question = obj.questions[index];
        currentIndex = question.answers.length;
        identifyType = this.getNumberType(question.questionTypes.type);
        for (let index2 = 0; index2 < question.answers.length; index2++) {
          multipleOptionItems[index2] = {
            name: question.answers[index2].answer,
            id: question.answers[index2].idAnswer,
            img: question.answers[index2].img,
            emoji_type: question.answers[index2].answerEmojiType,
          };
          // multipleOptionItems[index2].id = question.answers[index2].idAnswer;
        }
        this.questions["question" + index] = {
          index: index,
          id: question.idQuestions,
          title: question.questionContent,
          type: identifyType.obj, //Es la leyenda debajo de la pregunta para ident el tipo de preg
          numberType: identifyType.index, // Es el identificador del tipo de pregunta
          multipleOptionItems,
          currentIndex,
          questionType: question.questionTypes.type, // es el texto del identificador de pregunta "radio_button"
        };

        index3++;
      }
      this.multiOptionContador = index3;
      this.indexQuestion = index3;
      this.surveyDescription = obj.details;
    },
    getNumberType: function (str) {
      let arrayTypes = [
        "radio_button",
        "binary",
        "range",
        "multiple_option",
        "emoji",
        "number",
        "open",
      ];

      let obj = {
        1: "Opción única",
        2: "Switch",
        3: "Slider",
        4: "Opción multiple",
        5: "Emoticons",
        6: "Calificación",
        7: "Pregunta abierta",
      };
      let index = arrayTypes.indexOf(str) + 1;
      return { index: str, obj: obj[index] };
    },
    convertTypeQuestion: function () {
      let obj = {
        "Opción única": "radio_button",
        Switch: "binary",
        Calificación: "number",
        "Opción múltiple": "multiple_option",
        Emoticons: "emoji",
        Slider: "range",
        "Pregunta abierta": "open",
      };
      let currentType = obj[this.newQuestionTitle];

      let idType = this.surveyTypes.questionTypes.filter(
        (type) => type.type === currentType
      );
      let resp = {
        type: currentType,
        id_type: idType[0].id,
      };

      return resp;
    },

    addMultiOptionInput: function (item) {
      let clonado = this.lodash.cloneDeep(this.questions);
      let index = Object.keys(item.multipleOptionItems);
      let lastKey = +index.pop();
      lastKey++;
      clonado["question" + item.index].multipleOptionItems[lastKey + ""] = {
        name: "",
      };
      clonado["question" + item.index].v = 1;
      clonado["question" + item.index].currentIndex = item.currentIndex + 1;
      this.questions = clonado;
    },
    removeMultiOptionInput: function (index, item) {
      let clonado = this.lodash.cloneDeep(this.questions);
      delete clonado["question" + item.index].multipleOptionItems[index + ""];
      this.questions = clonado;
    },
    createQuestion: async function () {
      try {
        let params = {
          question_content: this.fastQuestion,
          id_type: 9,
          id_surveys: this.$route.params.id,
          status: true,
          question_points: 1,
        };
        const resp = await api.createQuestion(params);
        this.idQuestion = resp.question.id;
      } catch (error) {
        throw error;
      }
    },
    createAnswer: async function (opcion, color) {
      try {
        let params = {
          answer: opcion,
          color: color,
          id_question: this.idQuestion,
        };
        const resp = await api.createAnswer(params);
        this.idAnswer.push(resp.dataAnswerQuestion.id);
      } catch (error) {
        throw error;
      }
    },
    fillSurveyTypes: async function () {
      try {
        const resp = await api.getAllSurveyTypes();
        this.surveyTypes = resp;
      } catch (error) {}
    },
    getSurveyInfById: async function () {
      this.$store.commit("global/SET_LOADING", true);

      try {
        const resp = await api.getSurveyById(this.$route.params.id);

        this.editSurveyInfo = resp.surveyInfo[0];
      } catch (error) {
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
  },
  async beforeMount() {
    await this.getSurveyInfById();

    this.isDetails = this.$route.params.isDetails
      ? this.$route.params.isDetails
      : false;
    this.isEditEvent = this.$route.params.edit
      ? this.$route.params.edit
      : false;
    // if (this.$route.params.surveyType === "multipleOptionSurvey") {
    await this.fillSurveyTypes();

    // }
    if (this.$route.params.create || this.$route.params.edit) {
      let parseDate = moment(this.$route.params.surveyObj.eventDateFrom);

      let addAWeek = parseDate.add(1, "week");

      this.date1 = moment(this.$route.params.surveyObj.eventDateFrom).format(
        "YYYY-MM-DD"
      );
      this.date2 = addAWeek.format("YYYY-MM-DD");
      this.time1 = "00:00";
      this.time2 = "00:00";
    } else if (this.isDetails || this.isEditEvent) {
      this.time1 = "00:00";
      this.time2 = "00:00";
      this.fillNormalSurvey(this.editSurveyInfo);
    }
  },
};
</script>

<style lang="scss">
.estimated {
  width: 40%;
}
.sendNotification {
  width: 50%;
  position: relative;
}
.sendNotification .notification {
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  left: 80%;
}
.sendNotification .notification input[type="checkbox"] {
  margin-left: 1rem;
}

.gray {
  color: #666666;
  @extend %audi;
}
.vs-collapse {
  background: #fff !important;
  border-radius: 0px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  z-index: 0;
}
.vs-collapse .card-header {
  background: #fff;
  border-bottom: 0px !important;
  @extend %audi-b;
  cursor: pointer;
  width: 92%;
}
.vs-collapse .icons {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
.vs-collapse .icons i {
  margin-left: 0.5rem;
  font-size: 1rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  z-index: 1;
  cursor: pointer;
}
.vs-collapse .multiple {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
.disabled-class {
  pointer-events: none;
  cursor: not-allowed;
}
.vs-collapse .multiple .input-option {
  position: relative;
  margin-bottom: 0.5rem;
}
.remove-opt {
  margin-left: 1rem;
  cursor: pointer;
  @extend %audi-b;
  &:hover {
    color: #bb0a30;
  }
}
#alert {
  width: 50%;
}
.vs-collapse .multiple .input-option i {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  left: -7%;
  color: #d9d9d9;
}
.vs-collapse .remove {
  cursor: pointer;
}
.vs-collapse .add-option {
  text-align: center;
  margin-bottom: 1rem;
}
.vs-collapse .add-option span {
  cursor: pointer;
}
.vs-collapse .switch {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 3rem;
  margin-left: 1rem;
  align-items: center;
  position: relative;
}
.vs-collapse .switch .img {
  position: absolute;
  left: 40%;
  top: 60%;
}
.vs-collapse .emoticons {
  display: flex;
  flex-direction: column;
}
.vs-collapse .emoticons .sentimiento-section {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vs-collapse .emoticons .selecciona {
  display: flex;
  flex-direction: row;
  width: 50%;
}
.vs-collapse .emoticons .sentimiento-section .sentimientos-imgs {
  width: 20%;
  border: 3px solid #333333;
  flex-wrap: wrap;
  text-align: center;
  position: absolute;
  left: 29%;
  background: #ffff;
}
.vs-collapse .emoticons .sentimiento-section .sentimientos-imgs img {
  width: 40%;
  cursor: pointer;
}

.vs-collapse .emoticons .selecciona ul {
  display: inline-flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.vs-collapse .emoticons .selecciona ul .emoticon-number {
  @extend %audi-b;
  font-size: 2rem;
  margin-left: 0.3rem;
}
.vs-collapse .emoticons .selecciona ul .select-emoticon {
  @extend %audi;
  font-size: 0.9rem;
  cursor: pointer;
}

.vs-collapse .emoticons .selecciona ul li img {
  width: 40%;
}
.vs-collapse .emoticons .sentimiento {
  width: 40%;
  margin-left: 3rem;
}
.vs-collapse .emoticons .sentimiento ul {
  list-style: none;
}
.vs-collapse .emoticons .sentimiento ul li p {
  @extend %audi;
  font-size: 1rem;
}
.vs-collapse .switch .input-option {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.vs-collapse .switch .input-option input {
  width: 70% !important;
}
.vs-collapse .open-question {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
.vs-collapse .open-question .text-area-option label {
  @extend %audi;
  font-size: 1rem;
}
.vs-collapse .open-question .text-area-option textarea {
  @extend %audi;
  font-size: 1rem;
  border: 1px solid #b3b3b3;
  width: 60%;
  max-height: 120px;
}
.vs-collapse .stars {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.vs-collapse .stars img {
  width: 45%;
  margin-bottom: 1rem;
}
.vs-collapse-item--header {
  position: relative;
  @extend %audi-b;
}
.vs-collapse-item--icon-header {
  top: 95%;
  right: 50% !important;
}
.fast-survey form {
  width: 50%;
}
.desaparecer {
  display: none;
}

.fast-survey .options {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}
.fast-survey .font-b {
  @extend %audi-b;
}
.fast-survey .add-question {
  display: flex;
}
.fast-survey .add-question .add-square {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 50px;
  height: 50px;
  background-color: #333333;
}
.fast-survey .add-question .add-square p {
  color: white;
  @extend %audi;
  font-size: 40px;
  margin-top: 10px;
}
.fast-survey .add-question #dropdownMenuButton > button {
  background-color: #333333;
  border-radius: 0px;
  color: #fff;
  @extend %audi;
  height: 50px;
  width: 10rem;
  &::after {
    content: "";
    display: none;
  }
}
.fast-survey .add-question #dropdownMenuButton > button[aria-expanded="true"] {
  color: #666666;
}
.fast-survey .add-question #dropdownMenuButton > ul {
  border-radius: 0px;
  text-align: left;
  @extend %audi;
  top: -3px !important;
}
.fast-survey .add-question #dropdownMenuButton .dropdown-item.active,
.dropdown-item:active {
  background-color: #333333;
}
.fast-survey .validity .dates {
  display: flex;
  align-items: center;
}
.fast-survey .validity .dates .date-from,
.fast-survey .validity .dates .date-to {
  display: flex;
  flex-direction: column;
  width: 40%;
}
.fast-survey .validity .dates .time-from,
.fast-survey .validity .dates .time-to {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
}
.vue__time-picker {
  margin-top: -7px;
}
.fast-survey .validity .dates .date-to {
  margin-left: 3rem;
}
.fast-survey .footer-buttons {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2rem;
}
.fast-survey .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.fast-survey .cancel-btn {
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;
  color: #000;
  text-decoration: none;
}
.fast-survey .cancel-btn:hover {
  text-decoration: underline;
}
.fast-survey .btn-save {
  color: #fff;
  background-color: #000;
  border-color: #000;
  padding: 10px 20px;
  border-radius: 0px;
  border: none;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  margin-left: 15px;
  &:hover {
    background-color: #bb0a30;
    border-color: #bb0a30;
  }
}
</style>
